export default {
    body: "monday.com, ranked #1 for productivity, helps teams manage and execute projects that deliver results on time."
};
